import React from "react"
import { Route, Routes } from "react-router-dom"
import { ReportFilterContextProvider } from "../context/ReportFilterContext"
import NotFound from "../features/notFound/pages/NotFound"
import { OverviewLocation } from "../features/dashboard/widgets/OverviewLocation"
import { OverviewDevice } from "../features/dashboard/widgets/OverviewDevice"

export const OverviewRoutes = () => {
    return (
    <ReportFilterContextProvider>
        <Routes>
          <Route path="location/*" element={<OverviewLocation />} />
          <Route path="group/*" element={<OverviewLocation />} />
          <Route path="device/*" element={<OverviewDevice />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ReportFilterContextProvider>)
}